import jwt_decode from "jwt-decode";
import { toast } from "react-toastify";

/**
 * Pure JWT decode utility with no UI side-effects or storage mutations.
 */
export const tokenDecodeSafe = (tokenInput?: string | null): any => {
  try {
    const token = tokenInput || localStorage.getItem("us_st_d");
    if (!token) return null;

    const decoded: any = jwt_decode(token);
    return decoded || null;
  } catch (error) {
    return null;
  }
};

/**
 * Token decoder with session validation.
 */
export const tokenDecode = (tk_access?: any) => {
  try {
    if (tk_access && typeof tk_access === "string") {
      localStorage.setItem("us_st_d", tk_access);
    }

    const token = localStorage.getItem("us_st_d");
    if (!token) {
      return false;
    }

    const decoded: any = jwt_decode(token);
    const expirationDate = new Date(decoded?.exp * 1000);
    const now = new Date();

    if (expirationDate < now) {
      localStorage.removeItem("us_st_d");
      return false;
    }
    return decoded;
  } catch (error) {
    return false;
  }
};
